const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Lithium+SSO+Token

function getLithiumSSOToken(profileId) {
    const url = `/api/users/profiles/${profileId}/lithiumSsoToken`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data.lithiumSsoToken));
}

module.exports = getLithiumSSOToken;
